import { render } from "./TotalInfo.vue?vue&type=template&id=6e181360&ts=true"
import script from "./TotalInfo.vue?vue&type=script&lang=ts"
export * from "./TotalInfo.vue?vue&type=script&lang=ts"

import "./TotalInfo.vue?vue&type=style&index=0&id=6e181360&lang=less"

import exportComponent from "/Users/junyichen/AffaMed/hda-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__